import React from 'react';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
import { money, dollars } from '../jarvis/Ring';

export { money, dollars };
export const clamp01 = (v) => Math.max(0, Math.min(1, Number(v) || 0));
export const plural = (n, w) => `${n} ${w}${Number(n) === 1 ? '' : 's'}`;
export const fmtUnit = (v, unit) => (unit === 'files' ? `${Math.round(Number(v) || 0)} files` : money(v));
export const fmtUnitFull = (v, unit) => (unit === 'files' ? `${Math.round(Number(v) || 0)} files` : dollars(v));

export const TONE_LABEL = { green: 'Ahead', blue: 'On pace', amber: 'Behind', red: 'Well behind', grey: 'No target' };

/* Ahead / behind pill derived from a pace block. */
export function StatusPill({ block, testid }) {
  if (!block || !block.target) return <span className="gpc-st grey" data-testid={testid}>No target</span>;
  if (block.met) return <span className="gpc-st green" data-testid={testid}>Target met</span>;
  const up = block.variance >= 0;
  const label = up ? 'Ahead of pace' : 'Behind pace';
  const tone = up ? 'green' : block.tone === 'red' ? 'red' : 'amber';
  return (
    <span className={`gpc-st ${tone}`} data-testid={testid}>
      {up ? <ArrowUpRight /> : <ArrowDownRight />} {label} · {fmtUnit(Math.abs(block.variance), block.unit)}
    </span>
  );
}

/* Signed delta chip (percentage) for like-for-like comparisons. */
export function Delta({ pct, testid }) {
  if (pct == null) return <span className="gpc-d flat" data-testid={testid}><Minus /> n/a</span>;
  const up = pct > 0.5, dn = pct < -0.5;
  return (
    <span className={`gpc-d ${up ? 'up' : dn ? 'dn' : 'flat'}`} data-testid={testid}>
      {up ? <ArrowUpRight /> : dn ? <ArrowDownRight /> : <Minus />}{Math.abs(pct).toFixed(0)}%
    </span>
  );
}

/* Section wrapper with an eyebrow label; anchors drive the sticky section nav. */
export function Section({ id, label, hint, children }) {
  return (
    <div id={id} className="gpc-section" data-testid={`gpc-section-${id}`}>
      <div className="gpc-eyebrow">{label}{hint && <span>{hint}</span>}</div>
      {children}
    </div>
  );
}
